import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const ServiceFlagsContext = createContext({});

export const ServiceFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/service-flags`)
      .then(({ data }) => setFlags(data.flags || {}))
      .catch(() => {});
  }, []);

  // Single key — defaults to enabled if not set
  const isEnabled = (key) => !key || flags[key] !== false;

  // Cards tile: show if either naira OR usd is enabled
  const isCardsEnabled = () => isEnabled("NAIRA_CARD") || isEnabled("USD_CARD");

  return (
    <ServiceFlagsContext.Provider value={{ flags, isEnabled, isCardsEnabled }}>
      {children}
    </ServiceFlagsContext.Provider>
  );
};

export const useServiceFlags = () => useContext(ServiceFlagsContext);
